<template>
	<div>
		<el-submenu v-if="item.children" :index="item.path">
			<template slot="title">
				<i :class="item.icon"></i>
				<span slot="title">{{item.title}}</span>
			</template>
			<menu-item v-for="(child,i) in item.children" :item="child" :key="i"></menu-item>
		</el-submenu>
		<el-menu-item v-else :index="item.path">
			<i :class="item.icon" :style="item.icon ? '' : 'width:10px;'"></i>
			<span slot="title">{{item.title}}</span>
		</el-menu-item>
	</div>
</template>
<script>
export default {
	name: 'MenuItem',
	props: {
		item: {
			type: Object,
			required: true
		},
	},
	data() {
		return {

		}
	}
}
</script>
<style lang="scss" scoped>
.el-menu{
		height: 100%;
		border-right: none;
		background-color: #20335D;
		.el-menu-item{
			background-color: #20335D;
			&:hover{
				background-color: rgba(14, 21, 37, 1);
			}
		}
		.el-menu-item.is-active{
			background-color: rgba(14, 21, 37, 1);
		}
		/deep/ .el-submenu__title{
			background-color: #20335D;
		}
		/deep/ .el-submenu__title:hover{
			background-color: rgba(14, 21, 37, 1);
		}
		/deep/ .el-menu-item-group__title{
			padding: 0;
		}
	}

.el-submenu{
		width: 200px;
		.el-menu-item{
			min-width: 199px;
		}
	}
	.el-submenu,
	.el-menu-item{
		i{
			display: inline-block;
			margin-right: 10px;
		}
		.yakult-icon-1{
			width: 16px;
			height: 16px;
			background: url('~@/assets/images/1.png') no-repeat;
			background-size: 16px 16px;
		}
		.yakult-icon-2{
			width: 16px;
			height: 16px;
			background: url('~@/assets/images/2.png') no-repeat;
			  background-size: 16px 16px;
		}
		.yakult-icon-3{
			width: 16px;
			height: 16px;
			background: url('~@/assets/images/3.png') no-repeat;
			  background-size: 16px 16px;
		}
		.yakult-icon-4{
			width: 16px;
			height: 16px;
			background: url('~@/assets/images/4.png') no-repeat;
			  background-size: 16px 16px;
		}
		.yakult-icon-5{
			width: 16px;
			height: 16px;
			background: url('~@/assets/images/5.png') no-repeat;
			  background-size: 16px 16px;
		}
		.yakult-icon-6{
			width: 18px;
			height: 16px;
			background: url('~@/assets/images/6.png') no-repeat;
			background-size: 18px 16px;
		}
		.yakult-icon-7{
			width: 16px;
			height: 16px;
			background: url('~@/assets/images/7.png') no-repeat;
			  background-size: 16px 16px;
		}
	}
</style>
